import { Dialog, DialogBody, DialogTitle, EditProps } from '@/components/base/dialog'
import { EditMaintenanceEventQuery } from './__generated__/edit_query'
import { Query } from './edit_query'
import { Form as EditForm } from './edit_form'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'

export const EditDialog = ({ id, open, setOpen }: EditProps) => {
  const { data, loading } = useQuery<EditMaintenanceEventQuery>(Query, { variables: { filters: { idEq: id } } })

  const maintenanceEvent = data?.maintenanceEvents.nodes[0]

  return (
    <>
      <Dialog open={open} size="5xl" onClose={setOpen}>
        <DialogTitle>
          <div>
            {
              loading || !maintenanceEvent
                ? <Loading />
                : `${maintenanceEvent.maintenanceType.name} on ${maintenanceEvent.asset.name}`
            }
          </div>
        </DialogTitle>
        <DialogBody>
          <EditForm id={id} onSuccess={() => setOpen(false)} />
        </DialogBody>
      </Dialog>
    </>
  )
}
